import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { configApi } from '../../configApi';
import { IScorePreview, ISubmitResponse } from './types';

const submitSubmission = async (submissionId: string): Promise<ISubmitResponse> => {
  const response = await configApi.post<ISubmitResponse>(
    `/api/title-submissions/${submissionId}/submit/`
  );
  return response.data;
};

export const useSubmitTitleSubmission = (submissionId: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => submitSubmission(submissionId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['title-submission', submissionId] });
    },
  });
};

const reopenSubmission = async (submissionId: string) => {
  const response = await configApi.post(`/api/title-submissions/${submissionId}/reopen/`);
  return response.data;
};

export const useReopenTitleSubmission = (submissionId: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => reopenSubmission(submissionId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['title-submission', submissionId] });
    },
  });
};

const fetchScorePreview = async (submissionId: string): Promise<IScorePreview> => {
  const response = await configApi.get<IScorePreview>(
    `/api/title-submissions/${submissionId}/score-preview/`
  );
  return response.data;
};

export const useScorePreview = (submissionId: string | null) => {
  return useQuery({
    queryKey: ['title-submission-score-preview', submissionId],
    queryFn: () => fetchScorePreview(submissionId!),
    enabled: !!submissionId,
    refetchOnWindowFocus: false,
    staleTime: 1000 * 30,
  });
};
